import { ITargetingGroup } from "../../interfaces/ITargetingGroup";
import { ITargetingApplications } from "../../interfaces/ITargetingApplications";
import { IApplication } from "../../interfaces/IApplication";

export default class Utils {

    public capitalizeKeys = (obj) => {
        const isObject = o => Object.prototype.toString.apply(o) === '[object Object]';
        const isArray = o => Object.prototype.toString.apply(o) === '[object Array]';
        
        const transformedObj = isArray(obj) ? [] : {};
        
        for (const key in obj) {
          // replace the following with any transform function
          const transformedKey = key.replace(/^\w/, (c, _) => c?.toUpperCase());
      
          if (isObject(obj[key]) || isArray(obj[key])) {
            transformedObj[transformedKey] = this.capitalizeKeys(obj[key]);
          } else {
            transformedObj[transformedKey] = obj[key];
          }
        }
        return transformedObj;
    }

    public static validateProperties(targetingValues, targetingProperties) {
      const keys = Object.keys(targetingValues);

      targetingProperties.forEach((x) => {
        const values = keys.find(t => t === x.title);
        if (!values) {
          targetingValues[x.title] = [];
        }
      });

      return targetingValues;
    }

    public static parseTargetingGroupValues(groups: ITargetingGroup[]) {
      
      let values = "";

      if (groups && groups.length > 0) {
        groups.forEach((x) => {
          values += ";" + x.id + ";";
        });
      }

      return values;
    }

    public static checkIfUsesTargeting = (applicationData: ITargetingApplications, instance: string): boolean => {

      if (!applicationData) {
        return true;
      } else {
        const currentInstanceSettings = applicationData && applicationData.application && applicationData.application.instances ? applicationData.application.instances.find(x => x.id === instance || (instance === "Default" && x.name === instance)) : undefined;
        return currentInstanceSettings && (applicationData.application && applicationData.application.default && applicationData.application.default.isEnable) ? currentInstanceSettings.isEnable : (applicationData.application && applicationData.application.default ?  applicationData.application.default.isEnable : true);
      }
    }

    public static checkIfUsesTargetingByApplication = (applicationData: IApplication, instance: string): boolean => {

      if (!applicationData) {
        return true;
      } else {
        const currentInstanceSettings = applicationData && applicationData.instances ? applicationData.instances.find(x => x.id === instance || (instance === "Default" && x.name === instance)) : undefined;
        return currentInstanceSettings && (applicationData && applicationData.default && applicationData.default.isEnable) ? currentInstanceSettings.isEnable : (applicationData && applicationData.default ?  applicationData.default.isEnable : true);
      }
    }

}